import { QuestionTypes } from '@hotjar/feedback/domain/Surveys/Questions';

export const isCloseEndedType = (type) =>
  type === QuestionTypes.SINGLE_CLOSE_ENDED || type === QuestionTypes.MULTIPLE_CLOSE_ENDED;

export const isScaleType = (type) =>
  type === QuestionTypes.RATING_SCALE_5 ||
  type === QuestionTypes.RATING_SCALE_7 ||
  type === QuestionTypes.NET_PROMOTER_SCORE ||
  type === QuestionTypes.REACTION;

export const isTitleAndDescriptionType = (type) => type === QuestionTypes.TITLE_AND_DESCRIPTION;

export const isReactionType = (type) => type === QuestionTypes.REACTION;

const QUESTION_VALIDATIONS = [
  {
    fieldName: 'text',
    validate: (value) => value.length > 0,
  },
  {
    fieldName: 'answers',
    validate: (answers, questionType) => {
      if (isCloseEndedType(questionType)) {
        return answers.every((answer) => answer.text.length > 0);
      }
      return true;
    },
  },
  {
    fieldName: 'labels',
    validate: (labels, questionType) => {
      if (isScaleType(questionType)) {
        return labels.every((label) => label.text.length > 0);
      }
      return true;
    },
  },
];

export const validateQuestion = (question) =>
  QUESTION_VALIDATIONS.every((validation) =>
    validation.validate(question[validation.fieldName], question.type),
  );
